import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogContent, IconButton } from '@material-ui/core';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import ReactDataSheet from 'react-datasheet';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import VariablePicker from '../../../FlowConfigurationInputs/VariablePicker/VariablePicker';
import close from '../../../../assets/icons/close.svg';
import 'react-datasheet/lib/react-datasheet.css';

function Assign({ action, variables, setOpenVariable }) {

    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DATA-TABLE.ASSIGN.';
    const [tab, setTab] = useState(action.fields.tab?.value ? action.fields.tab.value : 'empty');
    const [data, setData] = useState(action.fields.table?.value ? action.fields.table.value : [
        ['', ''], ['', '']
    ]);
    const [selected, setSelected] = useState(null);
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!action.fields.type) { action.fields.type = 'DATATABLE'; }
        if (!action.fields.tab) { action.fields.tab = { value: 'empty', type: 'EMPTY' }; }
        if (!action.fields.table) { setData([['', ''], ['', '']]); }
        else { setData(action.fields.table.value); }
    }, [action]);
    const handleClick = (e) => {
        let value = e.target.value;
        action.fields.tab = { value, type: value.toUpperCase() };
        setTab(value);
    }
    // Handle cell value changes
    const onCellsChanged = changes => {
        const grid = data.map(row => [...row]);
        changes.forEach(({ cell, row, col, value }) => {
            grid[row][col] = value;
        });
        action.fields.table = { value: grid };
        // Update state
        setData(grid);
    }
    const handleDialogClick = () => { setOpen(true); }
    const handleClose = () => { setSelected(null); setOpen(false); }
    // Handle adding new row
    const handleAddRow = () => {
        let newRow = [];
        if (data[0]?.length) {
            // Push column values
            for (let i of data[0]) {
                newRow.push('');
            }
        } else { newRow.push(''); }
        data.push(newRow);
        // Add new row
        setData([...data]);
        setSelected(null);
    }
    // Handle adding new column
    const handleAddColumn = () => {
        for (let item of data) {
            // Push row values
            item.push('');
        }
        setData([...data]);
        setSelected(null);
    }
    // Handle removing row
    const handleRemoveRow = () => {
        // Remove row
        if (selected) {
            if (selected.end.i < selected.start.i) {
                if (selected.end.i === 0) {
                    if (selected.end.i === selected.start.i) { return; }
                    selected.end.i += 1;
                }
                data.splice(selected.end.i, selected.start.i - selected.end.i + 1);
            } else {
                if (selected.start.i === 0) {
                    if (selected.end.i === selected.start.i) { return; }
                    selected.start.i += 1;
                }
                data.splice(selected.start.i, selected.end.i - selected.start.i + 1);
            }
        }
        if (data.length === 0) { setData([['']]); }
        else { setData([...data]); }
        setSelected(null);
    }
    // Handle removing column
    const handleRemoveColumn = () => {
        if (selected) {
            for (let item of data) {
                if (selected.end.j < selected.start.j) {
                    item.splice(selected.end.j, selected.start.j - selected.end.j + 1);
                } else {
                    item.splice(selected.start.j, selected.end.j - selected.start.j + 1);
                }
            }
        }
        if (data[0].length === 0) { setData([['']]); }
        else { setData([...data]); }
        setSelected(null);
    }
    const handleSelect = (index) => { setSelected(index); }

    const getSelected = type => {
        if (selected.end[type] < selected.start[type]) {
            return selected.start[type] - selected.end[type] + 1;
        } else {
            return selected.end[type] - selected.start[type] + 1;
        }
    }

    return (
        <div>
            <div style={{ display: 'flex' }}>
                <div className="condition-tabs form-element">
                    <button className={tab === 'empty' ? 'condition-active' : ''} value="empty" onClick={handleClick}>
                        {t(label + 'EMPTY')}
                    </button>
                    <button className={tab === 'datatable' ? 'condition-active' : ''} value="datatable" onClick={handleClick}>
                        {t(label + 'TABLE')}
                    </button>
                    <button className={tab === 'variable' ? 'condition-active' : ''} value="variable" onClick={handleClick}>
                        {t(label + 'VARIABLE')}
                    </button>
                </div>
                {tab === 'datatable' && <Button onClick={handleDialogClick}><FullscreenIcon /></Button>}
            </div>
            {tab === 'variable' ?
                <div>
                    <div className="form-element">
                        {t(label + 'ASSIGN-VALUE')}
                        <TextInput action={action} inputName="assignValue" variables={variables} setOpenVariable={setOpenVariable} fieldType="data table" displayName={t(label + 'ASSIGN-VALUE')} />
                    </div>
                    <div className="form-element">
                        {t(label + 'ASSIGN-SOURCE')}
                        <VariablePicker action={action} inputName="assignSource" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired />
                        <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                    </div>
                </div> :
                tab === 'datatable' ?
                    <div>
                        <ReactDataSheet
                            data={data}
                            valueRenderer={cell => cell}
                            onCellsChanged={onCellsChanged}
                        />
                        {/* <Spreadsheet data={data}/> */}
                        <div className="form-element">
                            {t(label + 'ASSIGN-SOURCE')}
                            <VariablePicker action={action} inputName="assignSource" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired />
                            <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                        </div>
                    </div> :
                    <div>
                        <div className="form-element">
                            {t(label + 'ROW')}
                            <TextInput action={action} inputName="rowNumber" variables={variables} setOpenVariable={setOpenVariable} fieldType="number" displayName={t(label + 'ROW')} />
                        </div>
                        <div className="form-element">
                            {t(label + 'COLUMN')}
                            <TextInput action={action} inputName="columnNumber" variables={variables} setOpenVariable={setOpenVariable} fieldType="number" displayName={t(label + 'COLUMN')} />
                        </div>
                        <div className="form-element">
                            {t(label + 'ASSIGN-SOURCE')}
                            <VariablePicker action={action} inputName="assignSource" variables={variables} setOpenVariable={setOpenVariable} filter="data table" isRequired />
                            <small><em>{t('CONTENT.CONFIGURATION-FORM.VARIABLE-HELPER', { type: 'data table' })}</em></small>
                        </div>
                    </div>
            }
            <Dialog open={open} onClose={handleClose} maxWidth="lg">
                <DialogContent style={{ textAlign: 'center' }}>
                    <Button variant="outlined" onClick={handleAddRow} style={{ marginRight: 5, color: "#43AA41" }}>{t(label + 'ADD-ROW')}</Button>
                    <Button variant="outlined" onClick={handleAddColumn} style={{ marginRight: 5, color: "#43AA41" }}>{t(label + 'ADD-COLUMN')}</Button>
                    <Button variant="outlined" onClick={handleRemoveRow} disabled={!selected} style={{ marginRight: 5, color: !selected ? "#F5C6C6" : "#D75E5E" }}>
                        {t(label + 'REMOVE-ROW', { count: selected ? getSelected('i') : '' })}
                    </Button>
                    <Button variant="outlined" onClick={handleRemoveColumn} disabled={!selected} style={{ color: !selected ? "#F5C6C6" : "#D75E5E" }}>
                        {t(label + 'REMOVE-COLUMN', { count: selected ? getSelected('j') : '' })}
                    </Button>
                    <IconButton style={{ float: 'right' }} onClick={handleClose}><img src={close} alt="close-icon" /></IconButton>
                </DialogContent>
                <DialogContent>
                    <ReactDataSheet
                        data={data}
                        valueRenderer={cell => cell}
                        onSelect={handleSelect}
                        onCellsChanged={onCellsChanged}
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
}
export default Assign;